import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "font-normal font-openSans" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { class: "flex flex-wrap justify-between mt-1 sm:m-2" }
const _hoisted_4 = { class: "inline-flex items-center justify-start ml-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 text-xs font-normal sm:ml-2 text-nominee-black xl:text-sm" }, "Stay logged in? ", -1)
const _hoisted_6 = { class: "flex items-center text-right" }
const _hoisted_7 = {
  key: 0,
  class: "-mb-3 text-xs font-semibold text-center text-nominee-danger sm:p-2 sm:text-sm"
}
const _hoisted_8 = { class: "flex content-center m-auto mt-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "pr-1 text-xs text-nominee-black xl:text-sm" }, "Not a member? ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NTitle = _resolveComponent("NTitle")!
  const _component_NFormInput = _resolveComponent("NFormInput")!
  const _component_NSwitch = _resolveComponent("NSwitch")!
  const _component_NFormButton = _resolveComponent("NFormButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NTitle, {
      class: "mb-2 text-3xl sm:mb-6 sm:text-4xl",
      tag: "h1",
      content: "Log In"
    }),
    _hoisted_2,
    _createElementVNode("form", {
      class: "flex flex-col px-3 pt-4 pb-2 sm:pb-2 sm:pt-4 md:px-3 md:pb-2 lg:px-3 md:pt-5",
      onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["enter"])),
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createVNode(_component_NFormInput, {
        modelValue: _ctx.usernameInput,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.usernameInput) = $event)),
        class: "mb-2",
        type: "text",
        name: "username",
        error: !_ctx.loginFailed ? _ctx.usernameStatus.message : ' ',
        placeholder: "Username",
        onInputChanged: _ctx.resetUsernameStatus
      }, null, 8, ["modelValue", "error", "onInputChanged"]),
      _createVNode(_component_NFormInput, {
        modelValue: _ctx.passwordInput,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordInput) = $event)),
        class: "mb-1",
        type: "password",
        name: "password",
        error: !_ctx.loginFailed ? _ctx.passwordStatus.message : ' ',
        placeholder: "Password",
        onInputChanged: _ctx.resetPasswordStatus
      }, null, 8, ["modelValue", "error", "onInputChanged"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _createVNode(_component_NSwitch, {
            modelValue: _ctx.stayLoggedIn,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.stayLoggedIn) = $event)),
            name: "Stay logged in?"
          }, null, 8, ["modelValue"]),
          _hoisted_5
        ]),
        _createElementVNode("p", _hoisted_6, [
          _createElementVNode("span", {
            class: "p-1 text-xs font-bold text-gray-900 cursor-pointer md:text-sm",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToForgotPassword && _ctx.goToForgotPassword(...args)))
          }, "Forgot password?")
        ])
      ]),
      (_ctx.loginFailed)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Username or password is incorrect! "))
        : _createCommentVNode("", true),
      _createVNode(_component_NFormButton, {
        disabled: !_ctx.usernameStatus.valid || !_ctx.passwordStatus.valid || _ctx.loginFailed || _ctx.isProcessingLoginRequest,
        type: "submit",
        class: "w-full h-10 mt-3 lg:mt-5 sm:h-12",
        name: "LOGIN",
        loading: _ctx.isProcessingLoginRequest,
        onClick: _ctx.submitForm
      }, null, 8, ["disabled", "loading", "onClick"]),
      _createElementVNode("p", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("span", {
          class: "text-xs font-bold text-black cursor-pointer xl:text-sm",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToSignUp && _ctx.goToSignUp(...args)))
        }, "Signup now!")
      ])
    ], 32)
  ]))
}